module.exports = __webpack_public_path__ + "assets/images/ll-upsell-bg@2x-9a18fd21fc560ae25515ab7dcf180ecc.png";